(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('scrumboard', {
            parent: 'app',
            url: '/scrum-board',
            data: {
                authorities: ['ROLE_USER'],
            },
            ncyBreadcrumb: {
                label: 'ScrumBoard'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/scrumboard/scrumboard.html',
                    controller: 'ScrumBoardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('situacaoChamado');
                    $translatePartialLoader.addPart('tipoChamado');
                    $translatePartialLoader.addPart('situacaoTarefa');
                    $translatePartialLoader.addPart('situacaoSprint');
                    return $translate.refresh();
                }]
            }
        })
    }
})();
